import { render, staticRenderFns } from "./PersonalAwayPage.vue?vue&type=template&id=0cd859ea&scoped=true&"
import script from "./PersonalAwayPage.vue?vue&type=script&lang=js&"
export * from "./PersonalAwayPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd859ea",
  null
  
)

export default component.exports